import { useMatchRoute } from '@tanstack/react-router';
import { LinkRouterProps } from '@anytag/router';

export const useMatchPaths = (defaultPaths: ReadonlyArray<LinkRouterProps['to']> = []) => {
  const matchRoute = useMatchRoute();

  const matchPaths = (paths: ReadonlyArray<LinkRouterProps['to']>) =>
    paths.length > 0 ? paths.some((path) => !!matchRoute({ to: path, includeSearch: false })) : false;

  return {
    matched: matchPaths(defaultPaths),
    matchPaths,
    matchRoute
  };
};
